import axios from "axios";

export function sendEmailToUser(besafe_object_id) {
  return axios.get(`windows_clients/email_windows_installer?besafe_object_id=${besafe_object_id}`);
}

export function createWindowsExe() {
  return axios.post('windows_clients/build_windows_installer');
}

export function regenerateApiKey(user_id) {
  return axios.patch(`/besafe_objects/${user_id}/regenerate_api_key`);
}

export function updateAutoMode(user_id, is_auto_mode_enabled) {
  return axios.patch(`/besafe_objects/${user_id}/update_auto_mode`, { is_auto_mode_enabled });
}

export function resetTwoFactorAuth(user_id) {
  return axios.patch(`/besafe_objects/${user_id}/reset_two_factor_auth`);
}

export function updateTwoFactorAuthEnabled(user_id, enabled) {
  return axios.patch(`/besafe_objects/${user_id}/update_two_factor_auth_enabled`, {
    two_factor_auth_enabled: enabled
  });
}